module.exports = __webpack_public_path__ + "media/images/icons/file-pdf-6b19ff54c96cf9df0a15021499761ada.svg";